import { render, staticRenderFns } from "./RequestsView.vue?vue&type=template&id=2c69e41e&"
import script from "./RequestsView.vue?vue&type=script&lang=ts&"
export * from "./RequestsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c69e41e')) {
      api.createRecord('2c69e41e', component.options)
    } else {
      api.reload('2c69e41e', component.options)
    }
    module.hot.accept("./RequestsView.vue?vue&type=template&id=2c69e41e&", function () {
      api.rerender('2c69e41e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/member/requests/RequestsView.vue"
export default component.exports